// Canonical feature config shared between SharePlanModal and SharedPlanViewer.
// Each entry maps a feature key (from enabled_features) to its display info
// and optional subsection map (key → label). null subsections = no sub-toggles.

export const FEATURE_CONFIG = {
  pulse_view: {
    viewKey: 'pulse',
    label: 'Pulse',
    icon: 'monitor_heart',
    subsections: null,
  },
  strategy_view: {
    viewKey: 'strategy',
    label: 'Brief',
    icon: 'lightbulb',
    subsections: {
      shortSummary:        'Project Summary',
      problemStatement:    'Problem Statement',
      targetStatement:     'Audience',
      goalStatement:       'Possible Solution',
      objectivesStatement: 'Key Objectives',
    },
  },
  step_by_step_view: {
    viewKey: 'stepByStep',
    label: 'Action Plan',
    icon: 'draw',
    subsections: null,
  },
  calendar_view: {
    viewKey: 'calendar',
    label: 'Calendar',
    icon: 'view_timeline',
    subsections: null,
  },
  slick_view: {
    viewKey: 'slick',
    label: 'Overview',
    icon: 'map',
    subsections: null,
  },
  product_strategy_view: {
    viewKey: 'productStrategy',
    label: 'Strategy',
    icon: 'psychology',
    subsections: {
      designVision:               'Design Vision',
      briefDeconstruction:        'Brief Deconstruction',
      audienceInsights:           'Audience Insights',
      strategicThemes:            'Strategic Themes',
      designHypothesis:           'Design Hypotheses',
      competitiveUxPositioning:   'Competitive Positioning',
      experienceDesignPrinciples: 'Experience Design Principles',
      successMetrics:             'Success Metrics',
      opportunityAreas:           'Opportunity Areas',
    },
  },
  competitor_analysis_view: {
    viewKey: 'competitor',
    label: 'Competitor Analysis',
    icon: 'analytics',
    subsections: {
      executiveSummary:    'Executive Summary',
      statisticsDashboard: 'Key Statistics',
      marketIntelligence:  'Market Intelligence',
    },
  },
  decisions_view: {
    viewKey: 'decisions',
    label: 'Decisions',
    icon: 'gavel',
    subsections: {
      blockers:                 'Blockers',
      summary:                  'Current Strategic Position',
      recommendedNextSteps:     'Next Steps',
      strategicRecommendations: 'Strategic Recommendations',
      openQuestions:            'Open Questions',
    },
  },
  readme_view: {
    viewKey: 'readme',
    label: 'Documents',
    icon: 'description',
    subsections: null,
  },
};

// Ordered list of feature keys (determines tab order in SharedPlanViewer)
export const FEATURE_ORDER = [
  'pulse_view',
  'strategy_view',
  'step_by_step_view',
  'calendar_view',
  'slick_view',
  'product_strategy_view',
  'competitor_analysis_view',
  'decisions_view',
  'readme_view',
];
